// extracted by mini-css-extract-plugin
module.exports = {"intro":"TrovaSubitoSection_intro__BcO2o","title":"TrovaSubitoSection_title__3mc5d","list":"TrovaSubitoSection_list__uP_kl","ctaBox":"TrovaSubitoSection_ctaBox__BZ1Xx"};